import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { AppointmentButton } from '../AppointmentButton';

interface HeaderProps {
  currentSection: string;
  onBackNavigation: () => void;
}

export function Header({ currentSection, onBackNavigation }: HeaderProps) {
  return (
    <header className="fixed top-0 z-50 w-full max-w-[400px] bg-light">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center h-[52px]">
        {currentSection !== 'home' && currentSection !== 'menu' && (
          <button 
            onClick={onBackNavigation} 
            className="text-gray-600 hover:text-primary"
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
        )}
        <AppointmentButton 
          className="bg-primary text-white hover:bg-primary/90 font-barlow text-sm ml-auto"
        />
      </div>
    </header>
  );
}